export const faqsPl = [
  {
    q: "Czy projektujecie PCB od zera, czy tylko dopracowujecie istniejący schemat?",
    a: "Oba scenariusze. Projektujemy schemat i PCB od pomysłu, a także przejmujemy istniejące projekty — poprawiamy DFM, dobór komponentów, zasilanie i przygotowanie pod produkcję małej serii.",
  },
  {
    q: "Ile trwa prototyp elektroniki i PCB?",
    a: "Prosty prototyp na DevKit z podstawowym firmware często powstaje w 3–6 tygodni. Własne PCB z montażem i testami to zwykle 6–12 tygodni, zależnie od dostępności komponentów i złożoności układu.",
  },
  {
    q: "Czy zajmujecie się też obudową i mechaniką?",
    a: "Koordynujemy obudowę z partnerami mechanicznymi i projektujemy elektronikę pod realne wymiary, mocowania i wymagania IP. Samo wzornictwo przemysłowe możemy prowadzić z zewnętrznym designerem lub na Waszym briefie.",
  },
  {
    q: "Czy pomagacie w certyfikacji CE?",
    a: "Tak — projektujemy z myślą o EMC, bezpieczeństwie i dokumentacji potrzebnej do CE. Współpracujemy z laboratoriami i pomagamy domknąć ścieżkę certyfikacji przed produkcją seryjną.",
  },
  {
    q: "Czy możecie zbudować tylko elektronikę, bez aplikacji?",
    a: "Tak. Często zaczynamy od schematu, PCB i firmware PoC. Aplikację mobilną lub dashboard dorzucamy, gdy urządzenie jest gotowe do testów z użytkownikami.",
  },
  {
    q: "Na jakich platformach budujecie prototypy?",
    a: "Najczęściej STM32, ESP32, Nordic nRF oraz moduły LTE-M/NB-IoT. Do szybkiego PoC używamy DevKitów (np. Nordic Thingy), potem przechodzimy na własne PCB pod koszt i produkcję.",
  },
  {
    q: "Czy podpisujecie NDA przed rozmową o projekcie?",
    a: "Tak. Możemy podpisać NDA przed szczegółową rozmową — na naszym wzorze lub na dokumencie klienta.",
  },
  {
    q: "Od czego zależy koszt prototypu elektroniki?",
    a: "Od liczby warstw PCB, sensorów, wymagań bateryjnych, łączności (BLE, Wi-Fi, LTE-M), obudowy i zakresu firmware. Po krótkiej konsultacji dajemy orientacyjne widełki i plan etapów.",
  },
] as const;
